import { TenantBlock } from "~/components/common/deals/show/deal_card//block/TenantBlock";
import { DealBlock } from "~/components/common/deals/show/deal_card/block/DealBlock";
import { MoveOutBlock } from "~/components/common/deals/show/deal_card/block/MoveOutBlock";
import { RoomBlock } from "~/components/common/deals/show/deal_card/block/RoomBlock";
import type { Deal } from "~/models/Deal";
import Styles from "./DealCardModalForm.module.scss";

type Props = { deal: Deal };

export function DealCardModalForm({ deal }: Props) {
	return (
		<div className={Styles.Forms}>
			<RoomBlock deal={deal} />
			<TenantBlock />
			<MoveOutBlock />
			<DealBlock deal={deal} />
		</div>
	);
}
